/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import mineModule, { StorePlayServiceMineState } from './mine';
import detailModule, { StorePlayServiceDetailState } from './detail';
import listModule, { StorePlayServiceListState } from './list';
import recommendModule, { StorePlayServiceRecommendState } from './recommend';
import appraiseModule, { StorePlayServiceAppraiseState } from './appraise';
import otherModule, { StorePlayServiceOtherState } from './other';
import adminModule, { StorePlayServiceAdminState } from './admin';

export interface StorePlayServiceState {
  // modules
  mine: StorePlayServiceMineState;
  detail: StorePlayServiceDetailState;
  list: StorePlayServiceListState;
  recommend: StorePlayServiceRecommendState;
  appraise: StorePlayServiceAppraiseState;
  other: StorePlayServiceOtherState;
  admin: StorePlayServiceAdminState;
}

export default {
  namespaced: true,
  modules: {
    mine: mineModule,
    detail: detailModule,
    list: listModule,
    recommend: recommendModule,
    appraise: appraiseModule,
    other: otherModule,
    admin: adminModule,
  },
  state: {},
  getters: {},
  actions: {},
  mutations: {},
};
